import MuiList, { ListProps } from '@mui/material/List';

export interface IListProps extends ListProps {}

const List = (props: IListProps): JSX.Element => {
  return <MuiList {...props} />;
};

export default List;
